/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import { ReactComponent as PlusCircleSvg } from 'assets/icons/New/FilterBar/PlusCircle.svg';
import classes from './SaveToModal.module.scss';

const AddBlock = ({ className, entity, onClick, title }) => {
  return (
    <span className={cn(classes.addBlock, className)}>
      <span onClick={onClick}>
        <PlusCircleSvg />
        <span>{title || <>Add {entity}</>}</span>
      </span>
    </span>
  );
};

export default AddBlock;
